import { configureStore } from '@reduxjs/toolkit';
import ordersReducer from './pos/ordersSlice';
import tablesReducer from './pos/tablesSlice';
import menuReducer from './pos/menuSlice';
import branchReducer from './pos/branchSlice';
import posUIReducer from './pos/posUISlice';
import expensesReducer from './pos/expensesSlice';
import socketReducer from './pos/socketSlice';
import offlineReducer from './pos/offlineSlice';
import socketMiddleware from './pos/socketMiddleware';
import orderMirrorMiddleware from './pos/orderMirrorMiddleware';

const store = configureStore({
	reducer: {
		orders: ordersReducer,
		tables: tablesReducer,
		menu: menuReducer,
		branch: branchReducer,
		posUI: posUIReducer,
		expenses: expensesReducer,
		socket: socketReducer,
		offline: offlineReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).concat(socketMiddleware, orderMirrorMiddleware),
	devTools: process.env.NODE_ENV !== 'production'
});

// Expose the store on window so non-React modules (cloudLogger, etc.) can
// read state like the active branch without importing this file and creating
// circular dependencies.
if (typeof window !== 'undefined') {
	window.__POS_STORE__ = store;
}

export default store;


